import React from "react";
import RoundIcon from "../RoundIcon";
import Icon from "../Icon";
import PageContent from "../PageContent";

function PageReviewing() {
  return (
    <PageContent>
      <header />
      <h1>Reviewing</h1>

      <div className="panel bg-blue flex-row">
        <RoundIcon color="blue" >
          <Icon name="Info" color="white" />
        </RoundIcon>
        <div className="panel-content">
          <p>We are processing your application. We will notify you shortly when processing is complete.</p>
        </div>
      </div>
    </PageContent>
  );
}

export default PageReviewing;